export default {
  "projets": {
    "heroTitle": "مشاريعنا المنجزة",
    "heroSubtitle": "اكتشف إنجازاتنا عبر أفريقيا: أكثر من 1000 مشروع في 6 دول أفريقية",
    "stats": {
      "projects": "مشروع منجز",
      "countries": "دولة",
      "capacity": "القدرة المركبة"
    },
    "filters": {
      "categoryLabel": "الفئة",
      "regionLabel": "المنطقة",
      "resultsCount": "تم العثور على {{count}} مشروع",
      "categories": {
        "tous": "جميع المشاريع",
        "micro-reseaux": "الشبكات الصغيرة",
        "industriel": "صناعي",
        "residentiel": "سكني",
        "telecoms": "الاتصالات",
        "btp": "الهندسة المدنية والبناء",
        "medical": "طبي"
      },
      "regions": {
        "toutes": "جميع المناطق",
        "afrique": "أفريقيا",
        "asie": "آسيا",
        "ameriques": "الأمريكتان",
        "europe": "أوروبا"
      }
    },
    "photoGallery": {
      "badge": "معرض الصور",
      "title": "صور من مواقع عملنا",
      "subtitle": "صور حقيقية لتركيباتنا وتدخلاتنا في الميدان. انقر للتكبير.",
      "categories": {
        "tous": "جميع المواقع",
        "genie-civil": "الهندسة المدنية",
        "btp": "البناء والأشغال",
        "installation-electrique": "التركيب الكهربائي",
        "montage-solaire": "التركيب الشمسي"
      },
      "emptyState": "لا توجد صور في هذه الفئة"
    },
    "projectCard": {
      "capacity": "القدرة:",
      "beneficiaries": "المستفيدون:",
      "duration": "المدة:",
      "partners": "الشركاء:"
    },
    "emptyState": {
      "title": "لم يتم العثور على أي مشروع",
      "description": "حاول تعديل عوامل التصفية لرؤية المزيد من النتائج."
    },
    "cta": {
      "title": "هل مشروعك هو التالي؟",
      "subtitle": "انضم إلى عملائنا الراضين واستفد من خبرتنا في مشروع الطاقة المتجددة الخاص بك.",
      "quoteBtn": "طلب عرض سعر",
      "contactBtn": "اتصل بنا"
    },
    "list": [
      {
        "titre": "الشبكة الصغيرة الريفية زيمبابوي",
        "description": "تركيب كامل لشبكة صغيرة لكهربة 12 قرية ريفية مع نظام إدارة ذكي وتخزين ببطاريات الليثيوم.",
        "details": { "beneficiaires": "15,000 نسمة", "duree": "18 شهرًا", "partenaires": "البنك الدولي، حكومة زيمبابوي" }
      },
      {
        "titre": "المجمع الصناعي الصين",
        "description": "نظام هجين شمسي-شبكة للمنطقة الصناعية مع تحسين الطاقة وتخفيض 60% من تكاليف الكهرباء.",
        "details": { "beneficiaires": "50 شركة", "duree": "24 شهرًا", "partenaires": "الحكومة الإقليمية، غرفة التجارة" }
      },
      {
        "titre": "الحرم الجامعي الولايات المتحدة",
        "description": "تركيب شمسي مع تخزين لحرم جامعي، بما في ذلك محطات شحن المركبات الكهربائية.",
        "details": { "beneficiaires": "25,000 طالب", "duree": "12 شهرًا", "partenaires": "جامعة كاليفورنيا، وزارة الطاقة" }
      },
      {
        "titre": "المستشفى الريفي كمبوديا",
        "description": "نظام شمسي طارئ لمركز طبي مع تغذية مستمرة ونسخ احتياطي تلقائي.",
        "details": { "beneficiaires": "50,000 مريض/سنة", "duree": "8 أشهر", "partenaires": "منظمة الصحة العالمية، وزارة الصحة" }
      },
      {
        "titre": "شبكة الاتصالات بنين",
        "description": "تغذية شمسية لـ 50 موقع اتصالات مع مراقبة مركزية.",
        "details": { "beneficiaires": "2 مليون مشترك", "duree": "15 شهرًا", "partenaires": "مشغلو الاتصالات، ARCEP بنين" }
      },
      {
        "titre": "الشبكة الصغيرة النيجر",
        "description": "شبكة صغيرة مجتمعية لـ 8 قرى مع نظام دفع عبر الهاتف المحمول.",
        "details": { "beneficiaires": "12,000 نسمة", "duree": "20 شهرًا", "partenaires": "البنك الأفريقي للتنمية، الفاو" }
      },
      {
        "titre": "المزرعة الشمسية المغرب",
        "description": "مزرعة شمسية كبيرة متصلة بالشبكة الوطنية مع تقنية تتبع شمسي.",
        "details": { "beneficiaires": "100,000 أسرة", "duree": "30 شهرًا", "partenaires": "مازن، البنك الأوروبي" }
      },
      {
        "titre": "المركز التجاري فرنسا",
        "description": "تركيب شمسي على السطح مع استهلاك ذاتي وبيع الفائض.",
        "details": { "beneficiaires": "50,000 زائر/يوم", "duree": "6 أشهر", "partenaires": "منطقة أوفيرن-رون-ألب، ADEME" }
      },
      {
        "titre": "منجم الذهب بوركينا فاسو",
        "description": "نظام هجين شمسي-ديزل للتعدين مع تخفيض 40% من استهلاك الوقود.",
        "details": { "beneficiaires": "2,000 موظف", "duree": "18 شهرًا", "partenaires": "شركة التعدين، مؤسسة التمويل الدولية" }
      },
      {
        "titre": "المستشفى الإقليمي السنغال",
        "description": "نظام شمسي احتياطي لمستشفى إقليمي مع محولات طبية معتمدة.",
        "details": { "beneficiaires": "200,000 مريض/سنة", "duree": "10 أشهر", "partenaires": "وزارة الصحة، التعاون الفرنسي" }
      },
      {
        "titre": "الجامعة التكنولوجية الهند",
        "description": "حرم شمسي ذكي مع نظام إدارة الطاقة ومختبرات بحثية.",
        "details": { "beneficiaires": "30,000 طالب", "duree": "14 شهرًا", "partenaires": "حكومة كارناتاكا، اليونسكو" }
      },
      {
        "titre": "شبكة الاتصالات ساحل العاج",
        "description": "تغذية شمسية لبنية تحتية 4G/5G مع بطاريات احتياطية عالية السعة.",
        "details": { "beneficiaires": "5 ملايين مشترك", "duree": "12 شهرًا", "partenaires": "Orange CI، ARTCI" }
      },
      {
        "titre": "أساسات أبراج MTN — بنين",
        "description": "بناء 120 أساسًا خرسانيًا مسلحًا لأبراج الاتصالات ذاتية الدعم والمشدودة. أعمال الحفر والتسليح والقولبة وصب الخرسانة عبر 15 موقعًا في جميع أنحاء البلاد.",
        "details": { "beneficiaires": "3 ملايين مشترك", "duree": "10 أشهر", "partenaires": "MTN بنين، هواوي" }
      },
      {
        "titre": "الهيكل المعدني الصناعي — نيجيريا",
        "description": "تصنيع وتركيب 850 طنًا من الهياكل المعدنية لمستودع لوجستي بمساحة 12,000 متر مربع. عوارض شبكية ومدادات وتدعيم وتكسية مزدوجة.",
        "details": { "beneficiaires": "500 وظيفة", "duree": "14 شهرًا", "partenaires": "مجموعة دانغوتي، إريكسون" }
      },
      {
        "titre": "أساسات الاتصالات — بوركينا فاسو",
        "description": "بناء 200 أساس لأبراج الاتصالات في المناطق الريفية. دراسات جيوتقنية وأساسات سطحية وعميقة وشبكات تأريض.",
        "details": { "beneficiaires": "1.5 مليون مشترك", "duree": "8 أشهر", "partenaires": "أورانج بوركينا، نوكيا" }
      },
      {
        "titre": "مركز بيانات — السنغال",
        "description": "بناء جاهز لمركز بيانات بمساحة 3,200 متر مربع يشمل الأعمال الإنشائية والهيكل المعدني والعزل المائي والحزم التقنية ونظام تبريد مزدوج.",
        "details": { "beneficiaires": "المشغلون الإقليميون", "duree": "18 شهرًا", "partenaires": "سوناتيل، هواوي تكنولوجيز" }
      }
    ]
  }
};